import { render, staticRenderFns } from "./AllDone.vue?vue&type=template&id=1b13f88d&scoped=true&"
import script from "./AllDone.vue?vue&type=script&lang=js&"
export * from "./AllDone.vue?vue&type=script&lang=js&"
import style0 from "./AllDone.vue?vue&type=style&index=0&id=1b13f88d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13f88d",
  null
  
)

export default component.exports